import {BehaviorSubject} from 'rxjs';
import {activityApi} from '@/api/activity';

export const account$ = new BehaviorSubject('');

export function createKolState$(referralCode) {
  return activityApi.chekcKOLLandingPageExists(referralCode).toRestState();
}
